import ShopPaymentListResultModelBase from '../_generated/modelBases/shop-payment-list-result-model-base';

export default class ShopPaymentListResultModel extends ShopPaymentListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
